module.exports = __webpack_public_path__ + "img/swiper_button.1327a3a3.svg";